module.exports = __webpack_public_path__ + "static/SignUp-e9aa0100a41e87cd843972e65d64f386.svg";